import { beautyProfilerProductRepository } from "../repository/ProductRepository";
import { BeautyProfilerAllure, BeautyProfilerAllureId } from "../types/BeautyProfilerAllure";
import { ProfilerProduct, ProfilerProductId } from "../types/ProfilerProduct";

export const sortProductsByScore = (
  productScores: Map<ProfilerProductId, number>
): [ProfilerProductId, number][] => {
  return Array.from(productScores.entries()).sort(
    ([, scoreA], [, scoreB]) => scoreB - scoreA
  );
};

export const filterProductsByType = (
  productScores: Map<ProfilerProductId, number>,
  type: string
): [ProfilerProductId, number][] => {
  return sortProductsByScore(productScores).filter(([productId]) => {
    try {
      return beautyProfilerProductRepository.getProductById(productId).type === type;
    } catch (error) {
      console.error(`Failed to get product ${productId}:`, error);
      return false;
    }
  });
};

export const getTopProductByType = (
  productScores: Map<ProfilerProductId, number>,
  type: string
): [ProfilerProductId, number] | undefined => {
  return filterProductsByType(productScores, type).at(0);
}; 


export const findAllureById = (
  allures: BeautyProfilerAllure[],
  id: BeautyProfilerAllureId
): BeautyProfilerAllure | undefined => {
  return allures.find((allure) => allure.id === id);
};

export const findProductById = (
  products: ProfilerProduct[],
  id: ProfilerProductId
): ProfilerProduct | undefined => {
  return products.find((product) => product.id === id);
};

export const getRandomIdWithMaxScore = <T>(
  scores: Map<T, number>
): T => {
  const entries = Array.from(scores.entries());
  const maxScore = Math.max(...entries.map(([_, score]) => score));
  const maxEntries = entries.filter(([_, score]) => score === maxScore);
  const randomIndex = Math.floor(Math.random() * maxEntries.length);
  return maxEntries[randomIndex][0];
};